import { createSelector } from 'reselect'

export const getProfileAdsError = createSelector(
  state => state && state.user && state.user.profile && state.user.profile.ads && state.user.profile.ads.error
    ? state.user.profile.ads.error : null,
  error => error
)
